import React, { useEffect, useRef } from 'react'
import { IconAlert, IconWarning, InfoArrow, ModalClosed, ModalSuccess } from '~misc/icons';
import "./index.scss";
import useHeader from '~components/Header/hooks/useHeader';
import { Form, Formik } from 'formik';
import useModalUpdate from './hooks/useModalUpdate';
import { FormLabel } from '@chakra-ui/react';
import InputField from "~components/Form/components/InputField";
import Select from "~components/Form/components/Select";
import useContexto from '~/fetchs/useContexto';
import useLocal from '~/fetchs/useLocal';
import useModalEmail from './hooks/useModalEmail';

const ModalEmail = ({ isOpen, onClose, email, onConfirm }) => {
  const { initial, validation } = useModalEmail();
  const modalClasses = isOpen ? 'fixed inset-0 bg-black bg-opacity-0 z-[99999]' : 'hidden';
  const overlayClasses = isOpen ? 'fixed inset-0 bg-black opacity-50 ' : 'hidden';
  const formikRef = useRef();
  const onConfirmed = (e) => onConfirm(e);

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initial}
      validationSchema={validation}
      onSubmit={(values) => {
        onConfirmed(values);
      }}
    >
      {({ setFieldValue }) => (
        <Form className={modalClasses}>
          <div className="fixed inset-0 flex items-center justify-center  ">
            <div className="bg-white px-14 pt-14 rounded-[20px] shadow-lg  relative z-40 w-[500px] ">
              <div className="flex justify-end">
                <button type='button' onClick={onClose} className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0">
                  <ModalClosed />
                </button>
              </div>
              <div className='flex justify-center'>
                  <IconAlert />
              </div>
              <h2 className='font-bold text-2xl max-w-[400px] text-center mt-2 mb-6 ml-auto mr-auto'>Confirma o email abaixo?</h2>
              <InputField
                  labelName="Email:"
                  inputName="email"
                  inputType="email"
                  inputMask="offmask"
                  defaultValue={email}
                  setFieldValue={setFieldValue}
                  isRequired
                />
              <div className="py-6 flex justify-end container">
                <button type="submit" className="flex  items-center gap-x-2 text-white bg-quaternaria px-8 py-4 rounded font-bold credit-button-solicitacao">
                  Enviar
                  <InfoArrow />
                </button>
              </div>
            </div>
            <div className={overlayClasses} onClick={onClose}></div>
          </div>
        </Form>
      )}
    </Formik>


  )
}

export default ModalEmail
